import type { RdoSignatures } from "@/adapters/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { Rdo } from "../../types.ts";

const FIELDS: { key: keyof RdoSignatures; label: string }[] = [
	{ key: "diary", label: "Responsável pelo diário" },
	{ key: "technical", label: "Responsável técnico" },
	{ key: "contractor", label: "Contratante" },
];

interface SignaturesSectionProps {
	rdo: Rdo;
	readOnly: boolean;
	onChange: (patch: Partial<RdoSignatures>) => void;
}

export function SignaturesSection({
	rdo,
	readOnly,
	onChange,
}: SignaturesSectionProps) {
	return (
		<section className="rdo-editor__section" aria-labelledby="rdo-signatures">
			<h2 id="rdo-signatures" className="rdo-editor__section-title">
				Assinaturas
			</h2>
			<p className="rdo-editor__hint">
				Os nomes são impressos sob as linhas de assinatura do PDF.
			</p>
			<div className="rdo-editor__grid">
				{FIELDS.map((field) => (
					<div key={field.key} className="rdo-editor__field">
						<Label htmlFor={`rdo-signature-${field.key}`}>{field.label}</Label>
						<Input
							id={`rdo-signature-${field.key}`}
							defaultValue={rdo.signatures[field.key]}
							maxLength={200}
							disabled={readOnly}
							onChange={(event) => onChange({ [field.key]: event.target.value })}
						/>
					</div>
				))}
			</div>
		</section>
	);
}
